import ButterImage from '../../components/ButterImage'
import { BlogPostCategory } from '../../types'

type PostsPreviewProps = {
  readonly posts: ReadonlyArray<{
    readonly url: string
    readonly previewImage: string
    readonly previewImageDescription: string
    readonly previewTitle: string
    readonly previewDescription: string
    readonly category: ReadonlyArray<BlogPostCategory>
    readonly author: string
    readonly authorImage: string
  }>
}

export default function PostsPreview({ posts }: PostsPreviewProps) {
  return (
    <section>
      <ul style={{ listStyle: 'none' }}>
        {posts.map(
          (
            { url, previewDescription, previewImage, previewImageDescription, previewTitle },
            index,
          ) => (
            <li key={previewTitle + index}>
              <a href={`/${url}`}>
                <ButterImage
                  src={previewImage}
                  alt={previewImageDescription}
                  width={447}
                  height={235}
                  objectFit='cover'
                />

                <h2>{previewTitle}</h2>

                <p>{previewDescription}</p>
              </a>
            </li>
          ),
        )}
      </ul>
    </section>
  )
}
